const BREAKPOINTS = {
  mobile: 360,
  tablet: 768,
  desktop: 980,
  desktopXL: 1280,
}

const AUStatesOptions = [
  { label: 'Australian Capital Territory', value: 'ACT', abbreviation: 'ACT' },
  { label: 'New South Wales', value: 'NSW', abbreviation: 'NSW' },
  { label: 'Northern Territory', value: 'NT', abbreviation: 'NT' },
  { label: 'South Australia', value: 'SA', abbreviation: 'SA' },
  { label: 'Tasmania', value: 'TAS', abbreviation: 'TAS' },
  { label: 'Queensland', value: 'QLD', abbreviation: 'QLD' },
  { label: 'Victoria', value: 'VIC', abbreviation: 'VIC' },
  { label: 'Western Australia', value: 'WA', abbreviation: 'WA' },
]

const CAProvincesOptions = [
  { label: 'Alberta', value: 'AB', abbreviation: 'AB' },
  { label: 'British Columbia', value: 'BC', abbreviation: 'BC' },
  { label: 'Manitoba', value: 'MB', abbreviation: 'MB' },
  { label: 'New Brunswick', value: 'NB', abbreviation: 'NB' },
  { label: 'Newfoundland and Labrador', value: 'NL', abbreviation: 'NL' },
  { label: 'Northwest Territories', value: 'NT', abbreviation: 'NT' },
  { label: 'Nova Scotia', value: 'NS', abbreviation: 'NS' },
  { label: 'Nunavut', value: 'NU', abbreviation: 'NU' },
  { label: 'Ontario', value: 'ON', abbreviation: 'ON' },
  { label: 'Prince Edward Island', value: 'PE', abbreviation: 'PE' },
  { label: 'Quebec', value: 'QC', abbreviation: 'QC' },
  { label: 'Saskatchewan', value: 'SK', abbreviation: 'SK' },
  { label: 'Yukon', value: 'YT', abbreviation: 'YT' },
]

const CAProvincesOptionsFr = [
  { label: 'Alberta', value: 'AB', abbreviation: 'AB' },
  { label: 'La Colombie-Britannique', value: 'BC', abbreviation: 'BC' },
  { label: 'Le Manitoba', value: 'MB', abbreviation: 'MB' },
  { label: 'Le Nouveau-Brunswick', value: 'NB', abbreviation: 'NB' },
  { label: 'La Terre-Neuve-et-Labrador', value: 'NL', abbreviation: 'NL' },
  { label: 'Les Territoires du Nord-Ouest', value: 'NT', abbreviation: 'NT' },
  { label: 'La Nouvelle-Écosse', value: 'NS', abbreviation: 'NS' },
  { label: 'Le Nunavut', value: 'NU', abbreviation: 'NU' },
  { label: "L'Ontario", value: 'ON', abbreviation: 'ON' },
  { label: 'Île-du-Prince-Édouard', value: 'PE', abbreviation: 'PE' },
  { label: 'Le Québec', value: 'QC', abbreviation: 'QC' },
  { label: 'La Saskatchewan', value: 'SK', abbreviation: 'SK' },
  { label: 'Le Yukon', value: 'Yukon', abbreviation: 'YT' },
]

export { BREAKPOINTS, AUStatesOptions, CAProvincesOptions, CAProvincesOptionsFr }
